import { render, staticRenderFns } from "./DocumentByClientDatatableComponent.vue?vue&type=template&id=0cb27125&"
import script from "./DocumentByClientDatatableComponent.vue?vue&type=script&lang=js&"
export * from "./DocumentByClientDatatableComponent.vue?vue&type=script&lang=js&"
import style0 from "./DocumentByClientDatatableComponent.vue?vue&type=style&index=0&id=0cb27125&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports